import React, { useEffect, useRef } from 'react';
import { ReactElement } from 'react';
import { Button, Col, Row, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface IMultiselectDropdown {
  placeholder: string;
  options: any[];
  value: any;
  onChange: any;
  onSearch: any;
  filterKey?: any;
  ref?: any;
}
const MultiselectDropdown = ({
  placeholder,
  options,
  value = [],
  onChange = (): any => { },
  filterKey,
  onSearch = (): any => { } }: IMultiselectDropdown): ReactElement => {
  const { Option } = Select;

  const selectRef = useRef<any>(null);

  useEffect((): any => {
   if (selectRef.current) {
      setTimeout((): any  => {
        selectRef?.current?.focus();
      });
    }
  });

  const handleDropdownVisibleChange = (e: any): void => {
    e?.selectRef?.current?.scrollTo?.(0);
  };

  return (
    <div className="multi-select-dropdown">
      <Row className="custom-amount-range ant-input-affix-wrapper-focused">
        <Col md={22}>
          <Select
            mode="multiple"
            allowClear={true}
            className="w-100"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onSelect={onSearch}
            onDeselect={onSearch}
            ref={selectRef}
            onDropdownVisibleChange={(e: any): any => handleDropdownVisibleChange(selectRef?.current)}
            filterOption={(input: any, option: any): any => (option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0)}
          >
            {
              options?.length > 0 &&
              options?.filter((option: any, index: any, self: any): any =>
                filterKey === 'payerId' ? self?.findIndex((o: any): any => o?.key === option?.key) === index : true)
                ?.map(({ key, value: name, shortName }: any): ReactElement => {
                  const mappedOption = options?.find((option: any): any => option?.key === name);
                  const optionValue = filterKey ? (filterKey === 'payerId' ? (mappedOption?.name || shortName) : name) : name;
                  return (
                    <Option key={key} value={key}>
                      {optionValue}
                    </Option>
                  );
                })
            }
          </Select>
        </Col>
        <Col md={2}>
          <Button icon={<SearchOutlined />} onClick={onSearch} type="primary" className="w-100" />
        </Col>
      </Row>
    </div>
  );
};

export default MultiselectDropdown;
